import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { productSearchAlgoliaAccessorGetPricingData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetPricingData'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

type RetailPriceProps = ComponentPropsWithoutRef<'span'> & {
  hasDiscount: boolean
}

export const ProductSearchResultItemPriceContainerRetailPrice: FC<
  RetailPriceProps
> = ({ hasDiscount }) => {
  const { algoliaRecord } = useProductSearchResultItemContext()
  const { retailPriceFormatted, shouldShowPriceStartingFrom } =
    productSearchAlgoliaAccessorGetPricingData(algoliaRecord)

  return retailPriceFormatted ? (
    <span
      className={clsx(
        'text-xl font-bold',
        hasDiscount ? 'text-dark-error' : 'text-dark-primary-max',
      )}
      data-qa-id="entry-price"
    >
      {shouldShowPriceStartingFrom ? (
        <>
          <FormattedMessage id="general.label.price.from" />{' '}
        </>
      ) : null}

      {retailPriceFormatted}
    </span>
  ) : null
}
